import { SetUserDefinedProperty } from './helpers';

export function UserDefinedProperty(key: string, value: any) {
  return function(target: any, propertyKey: string) {
    SetUserDefinedProperty(target, propertyKey, key, value);
  }
}
